import axios from "axios";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useGlobalMessagesStore } from "./globalMessagesStore";
import { AuditComment } from "@/audit.types";
import { handleError } from "./storeHelper";

export const useAuditCommentStore = defineStore("auditCommentStore", () => {
    const loading = ref<boolean>(false);
    const items = ref<AuditComment[]>();
    const globalMessages = useGlobalMessagesStore();
    const apiUrl = 'api/v1/audit/comments';

    const list = async (auditId: number) => {

        try {
            loading.value = true;
            const response = await axios.get<AuditComment[]>(`${apiUrl}/${auditId}`);
            items.value = response.data;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
        finally {
            loading.value = false;
        }
    }

    const create = async (item: AuditComment): Promise<AuditComment> => {
        try {
            loading.value = true;
            const response = await axios.put<AuditComment>(apiUrl, item);
            globalMessages.push({ message: "Comment created successfully.", type: "success" })
            return response.data;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
        finally {
            loading.value = false;
        }
    }

    return {
        loading,
        create,
        items,
        list
    };
})